<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-converter" />
      </v-card-title>
    </v-card>
    <dialogWindow
      ref="AlertConverterSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertConverterSetup.dialog = false"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteCvtr"
      title="Delete Converter"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['converter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
  </div>
</template>
<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  name: 'process-converter',
  props: {
    comId: {
      default: '',
    },
    refName: {
      default: '',
    },
    isAddConverter: {
      default: false,
    },
    comTp: {
      default: 'CVT',
    },
    isHistory: {
      default: false,
    },
    cvtrTpCdList: {
      default: Array,
    },
    manage: {
      default: false,
    },
    manageDBB: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
      },
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      hideItem: true,
      hideIcon: 'fa fa-caret-down',
      hideText: 'Expand',
      tooltipWidth: 300,
      rulesComId: [],
      isDisableSave: false,
      replacePatternData: {
        sender: '',
        receiver: '',
        message: '',
      },
      nodeId: '',
      numOfUse: 0,
      arrCvtrGrp: [],
      formEmit: {
        comTp: 'CVT',
        comId: '',
        nodeId: '',
      },
      dbBrkList: [],
    };
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  created() {
    this.initialize();
    EventBus.$on('updateFormData', this.updateFormData);
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  destroyed() {
    EventBus.$on('updateFormData', this.updateFormData);
  },
  mounted() {},
  methods: {
    updateFormData(data) {
      if (this.nodeId === data.nodeInfo) this.resetForm();
      return;
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.cvtrId = id;
        if (!this.formData.cvtrId) {
          this.resetForm();
          return;
        }
        this.selectConverter();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.tooltipWidth = cfg.tooltipWidth;
      this.formData.cvtrId = this.comId;
      this.dbBrkList = this.dbBrokerSelectBoxList;
      if (!this.manageDBB && !this.isHistory) {
        this.dbBrkList = [];
      }

      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        if (this.formData.cvtrId !== '') {
          this.selectConverter();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
            cvtrTpCdList: this.cvtrTpCdList,
            dbBrkList: this.dbBrkList,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    // 2021.6.14 203728 Reset form
    resetForm() {
      this.formData = {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
        cvtrTpCd: '',
        srcPttn: '',
        repPttn: '',
        repPttnInput: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
        cvtrTpCdList: this.cvtrTpCdList,
        dbBrkList: this.dbBrkList,
        manage: this.manage,
        manageDBB: this.manageDBB,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    selectConverter() {
      const id = this.formData.cvtrId;
      let index = this.converterList.findIndex((e) => e.cvtrId == id);
      if (
        index > -1 &&
        (this.manage || this.isHistory) &&
        // reset if NOT have permission to manage DB Broker but converterList have item with type DB_CAPTOR
        (!(
          this.converterList[index].subList.some((e) => e.cvtrTpCd === 'DB_CAPTOR') &&
          !this.manageDBB
        ) ||
          this.isHistory)
      ) {
        this.arrCvtrGrp = this.converterList[index].subList;
        let listData = this.converterList[index].subList;

        for (let i = 0; i < listData.length; i++) {
          if (listData[i].cvtrTpCd === 'DB_CAPTOR') {
            const dupIndex = this.dbBrkList.findIndex((e) => e.value == listData[i].srcPttn);
            if (dupIndex === -1) {
              return this.resetForm();
            }
          }
        }
        this.formData = Object.assign({}, this.converterList[index]);
        if (this.formData.cvtrId === '1') {
          this.isDisableSave = true;
          this.formEmit = {
            comId: this.formData.cvtrId,
            nodeId: this.nodeId,
            comName: this.formData.cvtrNm,
            comTp: this.comTp,
            cvtrTpCdList: this.cvtrTpCdList,
            dbBrkList: this.dbBrkList,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
          EventBus.$emit('checkForCreateConverter', this.formEmit);
        } else {
          this.formEmit = {
            comId: this.formData.cvtrId,
            nodeId: this.nodeId,
            comName: this.formData.cvtrNm,
            comTp: this.comTp,
            cvtrTpCdList: this.cvtrTpCdList,
            dbBrkList: this.dbBrkList,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
          this.isDisableSave = false;
        }
      } else {
        this.resetForm();
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
    refreshPage() {
      this.checkHaveErrors = false;
      this.$refs.AlertConverterSetup.dialog = false;
    },
  },
  computed: {
    converterList() {
      return this.$store.getters.converterSelectBoxList;
    },
    dbBrokerSelectBoxList() {
      return this.$store.getters.dbBrokerSelectBoxList;
    },
  },
};
</script>
